import { useLeadershipWheelStore } from '../store/useLeadershipWheelStore';
import Button from '@/components/Button';
import { AnimatePresence } from 'framer-motion';

export const LeadershipWheelFinished = ({
  onClickShowLeadershipWheelTrackerButton,
  showCalendarAndRelatedContent,
}: {
  onClickShowLeadershipWheelTrackerButton: () => void;
  showCalendarAndRelatedContent?: boolean;
}) => {
  const { FocusArea, SubFocusArea } = useLeadershipWheelStore();

  const focusArea = FocusArea?.attributes;

  return (
    <AnimatePresence>
      <div className="mx-auto my-sh-30 flex max-w-[600px] flex-col items-center justify-center gap-y-8">
        <>
          <h1 className="text-center font-haffer text-sh-28-32">{focusArea?.focusArea || ''}</h1>
          <p className="text-center text-sh-14-18">{focusArea?.description}</p>
          <img
            src={focusArea?.overallMoodIcon?.data?.attributes?.url}
            className="h-24 w-24 md:h-[250px] md:w-[250px]"
            alt={focusArea?.focusArea}
          />
          <h2 className="max-w-[400px] text-center font-haffer text-sh-22-28 font-bold">
            {SubFocusArea?.microExercisePrompt?.title}
          </h2>

          <div
            className="w-full rounded-[16px] border border-[#A1C3EC] p-5 text-center [&>p]:text-sh-18-24"
            dangerouslySetInnerHTML={{
              __html: SubFocusArea?.microExercisePrompt?.content || '',
            }}
          />

          {!showCalendarAndRelatedContent && (
            <>
              <Button
                onClick={() => {
                  onClickShowLeadershipWheelTrackerButton();
                }}>
                Check your leadership wheel tracker
              </Button>
            </>
          )}
        </>
      </div>
    </AnimatePresence>
  );
};
